import { FC, ReactNode } from 'react';

import { Grid, Typography } from '@mui/material';

import { Flex } from 'src/components/Flex';

import { getStylesByPageHeaderVariant } from './util';

export enum PageHeaderVariant {
    DEFAULT = 'DEFAULT',
    DASHBOARD = 'DASHBOARD',
}

interface PageHeader {
    heading: string;
    subHeading?: string;
    callToActions?: ReactNode;
    variant?: PageHeaderVariant;
}

export const PageHeader: FC<PageHeader> = ({
    heading,
    subHeading,
    callToActions,
    variant = PageHeaderVariant.DEFAULT,
}) => {
    const styles = getStylesByPageHeaderVariant(variant, 'border.primary');
    return (
        <Flex sx={styles?.parentContainerStyles}>
            <Flex flexDirection="column">
                <Typography sx={styles?.headingStyles}>{heading}</Typography>
                {subHeading && <Typography sx={styles?.subHeadingStyles}>{subHeading}</Typography>}
            </Flex>
            {callToActions && (
                <Grid
                    item
                    md={7}
                    xs={12}
                    display="flex"
                    container
                    alignItems="center"
                    justifyContent="end"
                    sx={{
                        justifyContent: {
                            xs: 'center',
                            sm: 'center',
                            md: 'end',
                            lg: 'end',
                            xl: 'end',
                        },
                        flexDirection: {
                            xs: 'column',
                            sm: 'column',
                            md: 'row',
                            lg: 'row',
                            xl: 'row',
                        },
                    }}
                    gap={2}
                >
                    {callToActions}
                </Grid>
            )}
        </Flex>
    );
};
